import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import useBusinessConfiguration from '../../../hooks/useBusinessConfiguration';
import usePaymentFailureInformation from '../../../hooks/usePaymentFailureInformation';
import { SUBSCRIBED_LANDING_PAGE_EVENTS as EVENTS } from '../../../utils/analytics/events';
import { getCreateSubscriptionErrorCookie, getCreateSubscriptionSuccessCookie, removeCreateSubscriptionErrorCookie, removeCreateSubscriptionSuccessCookie, } from '../../../utils/cookies';
import GET_NOTIFICATION from './GET_NOTIFICATION';
var SUCCESS_BANNER = {
    kind: 'INFO',
    text: 'Pop bottles! You have successfully signed-up for a Refreshments membership.',
};
var ERROR_BANNER = {
    kind: 'ERROR',
    text: "Sorry, we've sold out! Come back 1st thing next month or check your email for when you can claim your offer.",
};
var useNotification = function () {
    var _a;
    var router = useRouter();
    var trackEvent = useBusinessConfiguration().trackEvent;
    var _b = usePaymentFailureInformation(), isUserInPaymentFailure = _b.isUserInPaymentFailure, hasUserUpdatedPaymentMethod = _b.hasUserUpdatedPaymentMethod, updatePaymentMethodURL = _b.updatePaymentMethodURL;
    var _c = useQuery(GET_NOTIFICATION), data = _c.data, loading = _c.loading;
    var banner = (_a = data === null || data === void 0 ? void 0 : data.me) === null || _a === void 0 ? void 0 : _a.banner;
    var successBannerCookie = getCreateSubscriptionSuccessCookie();
    var errorBannerCookie = getCreateSubscriptionErrorCookie();
    var successCreation = successBannerCookie && SUCCESS_BANNER;
    var errorCreation = errorBannerCookie && ERROR_BANNER;
    var bannerToShow = (banner || successCreation || errorCreation);
    var isBannerVisible = bannerToShow && !(isUserInPaymentFailure && hasUserUpdatedPaymentMethod);
    /**
     * Handler with the logic to be executed when the user clicks on the Banner Notification.
     */
    var handleOnClick = function () {
        if (!hasUserUpdatedPaymentMethod) {
            trackEvent(EVENTS.CLICK_ON_PAYMENT_FAILURE_BANNER);
        }
        if (banner === null || banner === void 0 ? void 0 : banner.link) {
            var link = isUserInPaymentFailure
                ? updatePaymentMethodURL
                : banner.link;
            router.push(link);
        }
    };
    /**
     * Track analytics events when the user lands on the Landing page with Payment Failure status.
     */
    useEffect(function () {
        if (!loading && isUserInPaymentFailure && !hasUserUpdatedPaymentMethod) {
            trackEvent(EVENTS.LAND_ON_WITH_PAYMENT_FAILURE);
        }
    }, [
        hasUserUpdatedPaymentMethod,
        isUserInPaymentFailure,
        loading,
        trackEvent,
    ]);
    /**
     * Remove the success and error cookies after showing the notification.
     */
    useEffect(function () {
        removeCreateSubscriptionSuccessCookie();
        removeCreateSubscriptionErrorCookie();
    }, []);
    return {
        bannerToShow: bannerToShow,
        isBannerVisible: isBannerVisible,
        handleOnClick: handleOnClick,
    };
};
export default useNotification;
